<script context="module">
  import {PATTERNS} from '@/const/patterns';

  function validateEmail(value, LG, lang) {
    if (value === null || LG === null) {
      return null;
    }
    if (PATTERNS.EMAIL.test(value)) {
      return null;
    }
    if (value) {
      return LG(lang.EmailError);
    }
    return LG(lang.NoEmailError);
  }
</script>

<script>
  import {createEventDispatcher} from 'svelte';
  import {PATHS} from '@/const/paths';
  import {mc} from '@/core';
  import {drawerUtil} from '@/helper/drawer';
  import {doCaptcha} from '@/captcha';
  import {userApi} from '@/api/user';
  import {fixLink$} from '@/store/lang';
  import Button from '@/widgets/Button.svelte';
  import DrawerModal from '@/widgets/DrawerModal.svelte';
  import lang from '../RegisterLandingPage.lang';

  export let LG = null;
  export let target = null;

  const dispatch = createEventDispatcher();

  let email = null;
  let isSubmitted = false;
  let errorMsg = null;
  let isLoading = false;

  $: {
    isSubmitted && submitData();
  }
  $: errorMsg = validateEmail(email, LG, lang);

  function handleClickClose() {
    dispatch('close');
  }

  function handleEnterKey(e) {
    if (e.keyCode === 13) {
      handleClickBtn();
    }
  }

  async function handleClickBtn() {
    if (email && errorMsg === null) {
      isSubmitted = true;
    }
  }

  async function submitData() {
    isLoading = true;
    const captchaResult = await doCaptcha('reset_pwd');
    if (!captchaResult) {
      mc.send('toast', 'error', {message: LG(lang.NetworkError)});
      isLoading = false;
      return;
    }

    const query = {
      type: 'mail-reset-password-code',
      email,
      ...captchaResult,
    };
    const {data, error} = await userApi.publicCodesMail(query);
    if (data) {
      drawerUtil.launchEmailVerification(LG, {
        type: 'mail-reset-password-code',
        context: {email: email},
        async callback(mailCode, callback, context) {
          const email = context.email;
          const data = await preparePassword(email, mailCode);
          callback(data);
        },
      });
      handleClickClose();
    }
    if (error) {
      mc.send('toast', 'error', error);
    }
    isSubmitted = false;
    isLoading = false;
  }

  async function preparePassword(email, mailCode) {
    const query = {
      mailCode,
      email,
    };
    const {data, error} = await userApi.preparePassword(query);
    if (data) {
      handleClickClose();
      drawerUtil.launchInputNewPassword(LG, {
        target,
        code: data.code,
      });
      return {code: 0, msg: ''};
    }
    if (error) {
      mc.send('toast', 'error', error);
      return {code: error.code, msg: error.message};
    }
  }
</script>

<style>
  .wrap {
    height: 100%;
  }
  .close-btn {
    margin-left: auto;
    width: 50px;
    height: 50px;
    background: #eff2f7;
    border-radius: 50%;
  }
  .close-btn:hover .iconfont {
    color: var(--T2);
  }
  .title {
    margin-top: 70px;
    font-size: 48px;
  }
  .sub-title {
    margin-top: 80px;
  }
  .ipt-box {
    padding: 0 18px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #dbdfe7;
  }
  .ipt-box.error {
    border: 1px solid #f66;
  }
  .ipt-box:focus-within,
  .ipt-box:hover {
    border: 1px solid #003fe6;
  }
  .ipt {
    height: 90%;
    border: none;
    outline: none;
  }
  .mt50 {
    margin-top: 50px;
  }
  .login-row {
    bottom: 80px;
  }
  .disabled {
    background: #efefef;
  }
</style>

<DrawerModal visible>
  <div class="wrap pr">
    <div class="tr">
      <div class="close-btn df aic jcc cp" on:click={handleClickClose}>
        <i class="iconfont f30 T4">&#xe614;</i>
      </div>
    </div>
    <div class="form">
      <div class="title">{LG(lang.ResetPassword)}</div>
      <div class="sub-title T4">{LG(lang.EnterYourDetailsBelow)}</div>
      <div class="ipt-box df aic mt20" class:disabled={isLoading} class:error={errorMsg}>
        <i class="iconfont T4">&#xe643;</i>
        <input class="autofill ml12 ipt f1" type="text" placeholder={LG(lang.Email)} disabled={isLoading} bind:value={email} on:keypress={handleEnterKey} />
      </div>
      {#if errorMsg}
        <div class="correct mt10">{errorMsg}</div>
      {/if}
      <div class="mt50">
        <Button minWidth="100%" type="primary" on:click={handleClickBtn} loading={isLoading}>{LG(lang.Continue)}</Button>
      </div>
      <div class="login-row pa">
        <span class="T4">{LG(lang.DontHaveAnAccount)}</span>
        <a class="BLUE cp" href={$fixLink$(PATHS.REGISTER.pathname)}>{LG(lang.GetStarted)}</a>
      </div>
    </div>
  </div>
</DrawerModal>
